<template>
	<div class="app_tips">
		<template v-if="type == 'loading'">
			<img :src="loading" />
			页面加载中...
		</template>
		<template v-else-if="404">
			<h1 style="color: #f00;">404</h1>
		</template>
	</div>
</template>

<script>
import loading from '@/assets/loading.gif';

export default
{
	name: 'tips',
	data (){
		return {loading}
	},
	props: ['type'],
}
</script>

<style scoped>
.app_tips {color: #f00;font-size: 14px;text-indent: 35%;margin-top: 5%;}
.app_tips img {display: inline-block;vertical-align: middle;}
</style>


// WEBPACK FOOTER //
// tips.vue?08baac56